import {BusinessLayout} from "../../../layouts/Business";
import {Info} from "../../../components/business/about/Info";
import {Support} from "../../../components/business/about/Support";
import {Feedback} from "../../../components/business/about/Feedback";

export const BusinessAboutPage = () => {
    return (
        <BusinessLayout>
            <Info/>
            <Support/>
            <Feedback/>
        </BusinessLayout>
    )
}